import { PlanCardType } from '@lib/sanity/queries/modules/pricingMain/types';
import Text, { TextVariant } from '@ui/Text/Text';
import cn from '@utils/cn';
import { usePricingFrequency } from '../PricingMain/PricingFrequencyContext';

const PlanFrequencySwitcher = ({ planCard, className }: { planCard: PlanCardType; className?: string }) => {
  const { isYearlyFrequency, setIsYearlyFrequency } = usePricingFrequency();

  if (!planCard.frequencySwitcher) {
    return null;
  }
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <Text content="ANNUAL" variant={TextVariant.TextBodySM} />
      <button
        type="button"
        role="switch"
        aria-checked={isYearlyFrequency}
        onClick={() => setIsYearlyFrequency(!isYearlyFrequency)}
        className={cn(
          'relative inline-flex h-4 w-7 shrink-0 items-center rounded-full border-0 p-0.5 transition-colors cursor-pointer',
          isYearlyFrequency ? 'bg-[#CA5936]' : 'bg-[#666666]',
        )}
      >
        <span
          className={cn(
            'pointer-events-none inline-block size-3 rounded-full bg-white shadow-sm transition-transform',
            isYearlyFrequency ? 'translate-x-3' : 'translate-x-0',
          )}
        />
      </button>
    </div>
  );
};

export default PlanFrequencySwitcher;
